
<template>
  <div class="flex items-center justify-center w-screen h-screen">
    <div class="text-center">
      <h1 class="mb-5 text-9xl">404</h1>
      <p>{{ $t('notfoundpage') }}</p>
      <v-btn
        class="primary mt-4"
        @click="goToHome"
        rounded
      >
        <v-icon left>mdi-arrow-left</v-icon>
        {{ $t('back_to_home') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound",
  created() {},
  data() {
    return {};
  },
  props: {},
  methods: {
    goToHome() {
      this.$router.push("/");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>

